import { ArrowUpRight } from "lucide-react";
import { Label } from "@/components/common/Reveal";
import { CONTACT } from "@/data/site";

const Block = ({ title, children }) => (
  <div className="border-t border-canvas-line py-7">
    <Label>{title}</Label>
    <div className="mt-4 space-y-1 text-ink">{children}</div>
  </div>
);

export const ContactDetails = () => (
  <aside data-testid="contact-details">
    <Block title="Email">
      <a href={`mailto:${CONTACT.enquiriesEmail}`} className="hover:text-brand" data-testid="contact-email">{CONTACT.enquiriesEmail}</a>
    </Block>
    <Block title="Phone">
      {CONTACT.phones.map((p) => (
        <a key={p.label} href={`tel:${p.tel}`} className="flex justify-between hover:text-brand" data-testid={`contact-phone-${p.label.toLowerCase()}`}>
          <span className="text-steel">{p.label}</span><span>{p.value}</span>
        </a>
      ))}
    </Block>
    <Block title="Office">
      {CONTACT.address.map((l) => <p key={l}>{l}</p>)}
    </Block>
    <Block title="Hours"><p>{CONTACT.hours}</p></Block>
    <Block title="Follow">
      <div className="flex gap-6">
        <a href={CONTACT.linkedin} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-brand" data-testid="contact-linkedin">LinkedIn <ArrowUpRight className="h-4 w-4" /></a>
        <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-brand" data-testid="contact-facebook">Facebook <ArrowUpRight className="h-4 w-4" /></a>
      </div>
    </Block>
  </aside>
);
